<!-- components/tweet/TweetMediaItem.vue -->
<template>
  <div class="relative w-full h-full overflow-hidden rounded-lg">
    <TweetVideoPlayer
      v-if="item.type === 'video' || item.type === 'gif'"
      :media-item="item"
      class="w-full h-full"
      @play="$emit('play')"
    />
    <NuxtImg
      v-else
      :src="item.src"
      :alt="'Media'"
      class="w-full h-full object-cover cursor-pointer"
      @click="$emit('click')"
    />
  </div>
</template>

<script setup lang="ts">
import type { MediaItem } from '@/stores/interfaces'

defineProps<{
  item: MediaItem
}>()

defineEmits<{
  click: []
  play: []
}>()
</script>
